import { render } from "./BaseErrorContainer.vue?vue&type=template&id=373e4e89&scoped=true"
import script from "./BaseErrorContainer.vue?vue&type=script&lang=js"
export * from "./BaseErrorContainer.vue?vue&type=script&lang=js"

import "./BaseErrorContainer.vue?vue&type=style&index=0&id=373e4e89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373e4e89"]])

export default __exports__